import React from 'react';
import './header.css';

export const Header = ({ title }) => {
  console.log()
  return (
    <h1 className="header-title">{title}</h1>
  )
}